export const baseUri = process.env.REACT_APP_API_BASE_URL;
